var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"cancel($event)\">\n&times;\n</button>\n<h3 class=\"modal-title\">Empty entire basket?</h3>\n</div>\n<form name=\"booking_form\" ng-submit=\"submit(modal_form)\">\n<div class=\"modal-body\">\n<p>Are you sure you wish to clear your basket?</p>\n</div>\n<div class=\"modal-footer\">\n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok()\">\nConfirm\n</button>\n<button type=\" button\" class=\"btn btn-default\" ng-click=\"cancel($event)\" translate=\"MEMBER.MODAL.EDIT_BOOKING.CANCEL_BTN\">\n</button>\n</div>\n</form>";
var id1="javascripts/basket/clear-basket/modal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../src/public/javascripts/basket/clear-basket/modal.html
// module id = 1364
// module chunks = 0